import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { AlertTriangle } from "lucide-react";
import api from "../../lib/api";

export default function AdminInventory() {
  const [products, setProducts] = useState([]);
  const [lowStock, setLowStock] = useState({ count: 0, items: [] });

  const load = async () => {
    setProducts((await api.get("/products?active_only=false")).data);
    setLowStock((await api.get("/inventory/low-stock")).data);
  };
  useEffect(() => { load(); }, []);

  const adjust = async (id, delta) => {
    await api.patch(`/inventory/${id}`, null, { params: { delta } });
    load();
  };
  const setStock = async (id, set_to) => {
    await api.patch(`/inventory/${id}`, null, { params: { set_to } });
    toast.success("Stock updated");
    load();
  };

  return (
    <div data-testid="admin-inventory">
      <div className="overline text-zinc-500">Inventory</div>
      <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight mb-6">Stock management</h1>

      {lowStock.count > 0 && (
        <div className="rounded-xl border border-amber-300 bg-amber-50 p-5 mb-6 flex items-start gap-3" data-testid="low-stock-alert">
          <AlertTriangle size={20} className="text-amber-600 mt-0.5" />
          <div>
            <div className="font-bold text-amber-900">{lowStock.count} item(s) running low</div>
            <div className="text-sm text-amber-800 mt-1">
              {lowStock.items.map((i) => `${i.name} (${i.stock})`).join(" · ")}
            </div>
          </div>
        </div>
      )}

      <div className="rounded-xl border border-zinc-200 bg-white overflow-hidden">
        <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-[700px]">
          <thead className="bg-zinc-50 text-zinc-500 text-xs">
            <tr>
              <th className="text-left px-5 py-3">Product</th>
              <th className="text-left px-5 py-3">Stock</th>
              <th className="text-left px-5 py-3">Threshold</th>
              <th className="text-right px-5 py-3">Adjust</th>
              <th className="text-right px-5 py-3">Set</th>
            </tr>
          </thead>
          <tbody>
            {products.map((p) => {
              const low = p.stock <= p.low_stock_threshold;
              return (
                <tr key={p.id} className="border-t border-zinc-100" data-testid={`inv-row-${p.id}`}>
                  <td className="px-5 py-3 font-semibold">{p.name}</td>
                  <td className="px-5 py-3">
                    <span className={low ? "text-amber-600 font-bold" : ""}>{p.stock}</span>
                  </td>
                  <td className="px-5 py-3 text-zinc-500">{p.low_stock_threshold}</td>
                  <td className="px-5 py-3 text-right">
                    <button onClick={() => adjust(p.id, -1)} className="px-2 py-1 text-xs border border-zinc-200 rounded">-1</button>
                    <button onClick={() => adjust(p.id, 1)} className="ml-1 px-2 py-1 text-xs border border-zinc-200 rounded" data-testid={`inv-inc-${p.id}`}>+1</button>
                    <button onClick={() => adjust(p.id, 10)} className="ml-1 px-2 py-1 text-xs border border-zinc-200 rounded">+10</button>
                  </td>
                  <td className="px-5 py-3 text-right">
                    <SetQty onSet={(n) => setStock(p.id, n)} />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
}
function SetQty({ onSet }) {
  const [v, setV] = useState("");
  return (
    <form onSubmit={(e) => { e.preventDefault(); if (v) onSet(Number(v)); setV(""); }} className="inline-flex gap-1">
      <input type="number" value={v} onChange={(e) => setV(e.target.value)} className="w-16 border border-zinc-200 rounded px-2 py-1 text-xs" placeholder="#" />
      <button className="text-xs px-2 py-1 bg-zinc-900 text-white rounded">Set</button>
    </form>
  );
}
